
<div>
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form skillcard">
      <!--<div class="modal-header">
    <h4 class="modal-title">Skill Assessment Sheets</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>-->

      <div  class="card-header wh-header">
        Skill Assessment Forms
        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

        <div class="modal-body">
          <!-- Form actions layout section start -->
          <section id="form-action-layouts">


            <div class="row justify-content-md-center">
              <div class="col-md-12">
                <div class="card">

                  <div class="card-body">
                    <div class="px-3">


                      <div class="form-body">
                        <div class="row">
                          <div class="form-group col-12 mb-2">
                            <label for="eventInput1">Select Form</label>

                            <CustomDataByRequestType RequestedType="FDTemplateWithTypeByActorReportTemlateCode" id="ActorReportTemplateCode" CustomType='{{ReportType}}' [(ngModel)]="ActorReportTemplateCode"
                                                     name="ActorReportTemplateCode" required>
                            </CustomDataByRequestType>
                            <!--(keyChange)="onFDTemplateByCode($event)"-->
                          </div>
                        </div>


                        <!--<div class="form-group">
                          <div class="col-md-12">
                            <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                          </div>
                        </div>-->


                      </div>



                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- // Form actions layout section end -->
        </div>


        <div class="modal-footer">
          <!--<button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>-->
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-primary modal-button-center">Save</button>

        </div>
      </form>
    </div>
    </div>
  </div>

